import React, { useState } from 'react'
import { DndProvider } from 'react-dnd-latest'
import { HTML5Backend } from 'react-dnd-html5-backend-latest'
import Myflowchart from '../../flowchart_port/FlowchartConnections/Myflowchart/Myflowchart'

// Myflowchart only seeds the Start node when 'flowchart-elements' is absent. If
// the key exists but has no Start (empty/invalid state), the canvas renders with
// no Start. Reset it in that case so a fresh Start is created.
const ensureStart = () => {
    try {
        const raw = sessionStorage.getItem('flowchart-elements')
        if (raw === null) return
        const arr = JSON.parse(raw)
        const hasStart =
            Array.isArray(arr) &&
            arr.some(
                (e) => e?.id === '0' || e?.data?.specificElType === 'start'
            )
        if (!hasStart) {
            sessionStorage.removeItem('flowchart-elements')
            sessionStorage.removeItem('flowchart-elements-id')
        }
    } catch {
        sessionStorage.removeItem('flowchart-elements')
        sessionStorage.removeItem('flowchart-elements-id')
    }
}

// AI-code "Code" step. Reuses the original flowchart editor as-is so the design,
// icons, colours, block logic and auto-connect behaviour are identical to the
// existing flowchart (no custom re-implementation).
const AiCodeFlow = () => {
    // Runs once before Myflowchart mounts (and reads flowchart-elements).
    useState(ensureStart)

    return (
        <DndProvider backend={HTML5Backend}>
            <Myflowchart aiCodeMode />
        </DndProvider>
    )
}

export default AiCodeFlow
